import { b as s, p as n, a as d } from "./blueprint-c6c4efc1.mjs";
import { createBlueprint as t } from "@made-people/blueprint";
const r = t({
  slots: {
    base: "flex justify-between items-center w-full col-span-12 sticky z-50 left-0 right-0 top-6 bg-white data-[is-pinned=true]:py-4 data-[is-pinned=true]:px-3 data-[is-pinned=true]:mx-2 data-[is-pinned=true]:w-[calc(100%-16px)] rounded-lg data-[is-pinned=true]:translate-y-2 transition-all data-[is-pinned=true]:shadow-sm",
    filterTrigger: "text-body-sm gap-2 flex items-center cursor-pointer",
    headerProducts: "text-body-sm"
  },
  variants: {}
});
export {
  s as productListBlueprint,
  r as productListHeaderBlueprint,
  n as productListHeaderMontevideoBlueprint,
  d as productListHeaderSaltoBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
